import { render, staticRenderFns } from "./site-payment.vue?vue&type=template&id=0fe08358&"
import script from "./site-payment.vue?vue&type=script&lang=js&"
export * from "./site-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports